import { render, staticRenderFns } from "./User_Permission_Form.vue?vue&type=template&id=8f409a28&"
import script from "./User_Permission_Form.vue?vue&type=script&lang=js&"
export * from "./User_Permission_Form.vue?vue&type=script&lang=js&"
import style0 from "./User_Permission_Form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports